
// 引入vue和vuex，进行全局状态管理
import Vue from 'vue'
import Vuex from 'vuex'

// 在vue项目中使用Vuex
Vue.use(Vuex)

// 配置
export default new Vuex.Store({
  // 实际状态，mapState应用在子组件中，对应于state，提供快捷的计算属性
  state: {
    myInfo: {}
  },
  // mutation 必须是同步函数
  mutations: {
    // obj 为路由信息对象
    communityInfoFn (state, obj) {
      state.myInfo = obj
    }
  },
  // 可以异步更改state的内容，内部调用的方法还是mutations，通过dispatch来分发
  actions: {
    decrease (context) {
      setTimeout(() => {
        context.commit('communityInfoFn')
      }, 1000)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js